import { injectCpmsBoAuthApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-auth.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoAuthApi = injectCpmsBoAuthApi(baseApi);

export const {
  useCpmsBoLoginMutation,
  useCpmsBoRequestLoginOtpMutation,
  useCpmsBoVerifyLoginOTPMutation,
  useCpmsBoRequestResetPasswordOtpMutation,
  useCpmsBoResetPasswordMutation,
  useCpmsBoRefreshTokensMutation,
  useCpmsBoLogoutMutation,
} = cpmsBoAuthApi;
